/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-undef */
import React, { useState } from "react";

import "../Login/login.css";

import { useTranslation } from "react-i18next";
import { Grid, Paper, Typography, Modal } from "@material-ui/core";
import { toast } from "react-toastify";
import { Form, Button } from "react-bootstrap";
import jwt_decode from "jwt-decode";
import { verifyOtp } from "../../config/service";
import InputForOtp from "../Login/InputForOtp";
import { useLocation, useNavigate } from "react-router-dom";
export const handleKeyPress = (event) => {
  if (event.key === "+" || event.key === "-" || event.key === ".") {
    event.preventDefault();
  }
};

const OtpModal = ({
  formData,
  open,
  setOpen,
  formValue,
  handleResendOtp,
  seconds,
  resendLoading,
  isResendDisable,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [otp, setOtp] = useState("");
  const [disablebutton, setDisableButton] = useState(false);
  const handleClose = () => setOpen(false);

  const OtpValidation = async (e) => {
    e.preventDefault();
    // store the states in the form data
    const role = "client";
    let data = {
      phone: formValue.mobile,
      otp: otp,
      role: role,
      id: formValue.id_number,
    };

    try {
      // make axios post request
      setDisableButton(true);
      const response = await verifyOtp(data);
      toast.success(t(response.data.msg));
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("refreshToken", response.data.refreshToken);
      const decodedToken = jwt_decode(response.data.token);
      localStorage.setItem("userName", decodedToken.name);
      localStorage.setItem("userId", decodedToken.id);
      localStorage.setItem("role", decodedToken.role);
      window.gtag("event", "login-success", {});
      navigate(
        {
          pathname: "/meetingrequest",
          search: location.search, // this keeps existing search params
        },
        {
          state: { meetingState: formData },
        }
      );
      setOpen(false);

      setDisableButton(false);
    } catch (error) {
      setDisableButton(false);
      setOtp();
    }
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ marginTop: "10%" }}
      >
        <Form onSubmit={OtpValidation}>
          <Grid container direction="column" alignItems="center">
            <Grid item xs>
              <Paper className="paper" square>
                <Grid container direction="column" alignItems="center">
                  <Grid item lg>
                    <Typography variant="h4" gutterBottom>
                      {t("Please Enter the OTP to Verify Your Account")}
                    </Typography>
                  </Grid>
                  <Grid item sm>
                    <Typography variant="h6" gutterBottom>
                      <span>{formValue.mobile} </span>
                      {t("An OTP(one time password) has been sent to")}
                    </Typography>
                  </Grid>

                  <Grid item xs>
                    <InputForOtp value={otp} onChange={setOtp} />
                  </Grid>
                  <Grid container direction="column" alignItems="center">
                    <Grid
                      item
                      xs
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        margin: "10px",
                      }}
                    >
                      <Button
                        disabled={disablebutton}
                        type="submit"
                        className="submit"
                        onClick={(e) => OtpValidation(e)}
                        style={{ maxWidth: "190px", margin: "0px auto" }}
                      >
                        {t("Validate OTP")}
                      </Button>
                      <Grid
                        item
                        sm
                        style={{
                          padding: "15px 0px",
                          margin: "0px auto",
                        }}
                      >
                        <Typography variant="h6">
                          {seconds ? <span>{seconds}</span> : t("")}
                        </Typography>
                      </Grid>
                      <div className="resend-btn-grid">
                        <Button
                          className="submit"
                          onClick={() => handleResendOtp("whatsapp")}
                          disabled={isResendDisable || resendLoading}
                        >
                          {t("Resend OTP on WhatsApp")}
                        </Button>
                        <Button
                          className="submit"
                          onClick={() => handleResendOtp("sms")}
                          disabled={isResendDisable || resendLoading}
                        >
                          {t("Resend OTP via SMS")}
                        </Button>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Form>
      </Modal>
    </div>
  );
};
export default OtpModal;
